export function ArrowIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 16 16">
      <path d="M3 8h9M8.5 4.5 12 8l-3.5 3.5" />
    </svg>
  )
}

export function Brand() {
  return (
    <a className="brand" href="#top" aria-label="SettlementOS home">
      <span className="brand-crop" aria-hidden="true">
        <img src="/logo-mark.png" alt="" />
      </span>
      <span>SettlementOS</span>
    </a>
  )
}
